import React from 'react';
import {useTranslation} from 'react-i18next';

import FormTitleSession from '@/components/FormTitleSession';

export default ({translation, title, help, content, ...rest}) => {
  
  // eslint-disable-next-line react/display-name
  return () => {
    const {t} = useTranslation(translation);
    
    return <FormTitleSession
      divider
      {...rest}
      translate={translation}
      title={title || t(title)}
      description={help || t(help)}
    >
      {content}
    </FormTitleSession>;
  };
};

//
